// extracted by mini-css-extract-plugin
export default {"alertCard":"LoanAlertCard_alertCard__RfeSJ"};